<template>
  <v-container
    fluid
    fill-height
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col>
        <div class="text-center">
          <p class="text-h4 white--text font-weight-medium">
            webcomet lite
          </p>
          <p class="text-subtitle-1 white--text mb-6">
            Create a FAQ section for your website in minutes <br>without registration using <span class="font-weight-medium">webcomet lite</span>
          </p>

          <v-dialog
            v-model="dialog"
            dark
            background="grey"
            width="600px"
          >
            <template #activator="{ on, attrs }">
              <v-btn
                dark
                depressed
                v-bind="attrs"
                v-on="on"
              >
                what is this?
              </v-btn>
            </template>
            <v-card flat>
              <v-card-title>
                What is webcomet lite?
                <v-spacer />
                <v-btn
                  icon
                  @click="dialog = false"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <p class="text-body-1">
                  webcomet lite is a very slimmed down version of the tool webcomet,
                  which is a fully-fledged system for managing FAQs.
                </p>
                <p class="text-body-1">
                  webcomet lite makes it possible to create FAQ sections very quickly without the need to register an account.<br>
                </p>
                <p class="text-body-1">
                  When you click 'Get started', we will generate a unique link that you will use to edit your FAQ section and give you a HTML snippet that you place on your website where you want the FAQ section to appear.<br>
                </p>
                <p class="text-body-1">
                  If you later on decide that you would like to try the full free version of webcomet, you can click the 'Sign up' button from the edit page and we will transfer your FAQ section to your account.
                </p>
                <p class="text-body-1 mb-0">
                  <a
                    href="https://www.webcomet.io"
                    class="white--text"
                  >Read more about the full version of webcomet here</a>
                </p>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-btn
            class="ml-2"
            color="primary"
            :loading="form.processing"
            :disabled="form.processing"
            dark
            rel="nofollow"
            @click="submit"
          >
            Get started
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/lite/components/TheLayout';

export default {
  layout: (h, page) => h(Layout, {
    props: {
      theme: 'dark'
    }
  }, [page]),

  data() {
    return {
      dialog: false,
      form: this.$inertia.form()
    }
  },

  methods: {
    submit() {
      const url = this.route('faq.lite.store');
      this.form.post(url);
    }
  }
}
</script>

<style>
  .v-overlay__scrim {
    background-color: #fff !important;
  }
</style>